function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/react-event-listener/~/@babel/runtime/helpers/getPrototypeOf.js
// module id = 731
// module chunks = 0